import moment from 'moment';
import { RangeModifier } from 'ha/ui/next/DatePicker';

import { ISODate } from 'ha/helpers/hadate/types';
import {
  getToday,
  isDayBetween,
  addDays,
  isBefore,
  diffDay,
  NO_END,
  NO_START,
} from 'ha/helpers/hadate';
import calculateMinimumSelectedDays from './calculateMinimumSelectedDays';

interface ExclusionDate {
  from: string;
  to: string;
}

type ExclusionsType = ExclusionDate | RangeModifier;

const isInCorrect = (date: ISODate): boolean =>
  moment(date).isSameOrAfter(NO_END) || moment(date).isSameOrBefore(NO_START);

export default (
  ranges: ExclusionsType[] = [],
  minimalPeriod = 0,
  minimalDate: string = getToday(),
): string | null => {
  if (!ranges.length) {
    return minimalDate;
  }

  const sorted = ranges.sort(
    (range1: ExclusionsType, range2: ExclusionsType) =>
      Number(moment(range1.from)) - Number(moment(range2.from)),
  );
  let guess: string = minimalDate;

  sorted.some(({ from, to }) => {
    if (isBefore(guess, from)) {
      const minimumSelectedDays = calculateMinimumSelectedDays(
        guess,
        minimalPeriod,
      );
      const diffInDays = diffDay(from, guess);
      const doesDayFit = diffInDays >= 0 && diffInDays > minimumSelectedDays;

      if (doesDayFit) {
        return true;
      }

      guess = addDays(to, 1);
    }
    if (isDayBetween(from, to, guess)) {
      guess = addDays(to, 1);
    }

    return false;
  });

  return isInCorrect(guess) ? null : guess;
};
